export default __webpack_public_path__ + "static/media/mysql.6fdb2596.svg";